<template>
  <v-card>
    <v-card-title class="grey lighten-5 headline">
      Departamentos Cadastrados
    </v-card-title>
    <v-row class="pa-4" justify="space-between">
      <v-col cols="5">
        <v-btn @click="novoRoot()" :disabled="!verificarPermissao(1)" color="primary">Novo Root</v-btn>
        <v-divider></v-divider>
        <v-treeview :items="departamentos" :open.sync="open" activatable color="info" transition>
          <template v-slot:prepend="{ item, open }">
            <v-icon v-if="!item.file">
              {{ open ? "mdi-folder-open" : "mdi-file" }}
            </v-icon>
            <v-icon v-else>
              {{ files[item.file] }}
            </v-icon>
          </template>
          <template slot="label" slot-scope="{ item }">
            <a @click="carregarDados(item)">{{ item.name }}</a>
          </template>
        </v-treeview>
      </v-col>

      <v-divider vertical></v-divider>

      <v-col class="text-center">
        <v-scroll-y-transition mode="out-in">
          <div v-if="!departamento" class="title grey--text text--lighten-1 font-weight-light pt-6"
            style="align-self: center">
            Selecione um Departamento
          </div>
          <v-card v-else :key="departamento.id" class="pt-6 mx-auto" flat max-width="400">
            <v-card-text>
              <i class="fas fa-building fa-5x"></i>
              <h6 class="mb-2 mt-4">NOME DO DEPARTAMENTO</h6>
              <h3 class="headline mb-2">
                {{ departamento.nome }}
              </h3>
            </v-card-text>
            <div v-if="departamento.id !== 0">
              <v-divider></v-divider>
              <v-card-actions class="justify-center">
                <download-excel :ref="'download-relatorio-pendencias-' + this.departamento.nome
                  " class="d-none" :data="configExportarPendencias.pendenciasExportar"
                  :name="configExportarPendencias.nomeArquivo">
                </download-excel>
                <v-btn v-if="departamento.departamentoSuperiorID == null &&
                  verificarPermissao(1)
                  " color="info" fab x-small dark @click="novoCadastro()"
                  title="Novo Departamento Filho"><v-icon>mdi-plus</v-icon></v-btn>&nbsp;

                <v-menu offset-y close-on-content-click>
                  <template v-slot:activator="{ on: menu, attrs }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on: tooltip }">
                        <v-btn v-bind="attrs" v-on="{ ...menu, ...tooltip }" color="primary" fab x-small dark
                          class="ml-2"><v-icon>mdi-file-excel</v-icon></v-btn>
                      </template>
                      <span>Relatório de pendências</span>
                    </v-tooltip>
                  </template>
                  <v-list>
                    <v-list-item @click="downloadRelatorioPendencias()">
                      <v-list-item-title>Todas Pedencias</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="downloadRelatorioPendenciasStatus(1)">
                      <v-list-item-title>Aprovado</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="downloadRelatorioPendenciasStatus(0)">
                      <v-list-item-title>Reprovado</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="downloadRelatorioPendenciasStatus(2)">
                      <v-list-item-title>Aguardando Arquivos</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="downloadRelatorioPendenciasStatus(3)">
                      <v-list-item-title>Aguardando Aprovação</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>&nbsp;

                <v-menu offset-y close-on-content-click>
                  <template v-slot:activator="{ on: menu, attrs }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on: tooltip }">
                        <v-btn v-bind="attrs" v-on="{ ...menu, ...tooltip }" color="green" fab x-small dark
                          class="ml-2"><v-icon>mdi-file-excel</v-icon></v-btn>
                      </template>
                      <span>Relatório de pendências (apenas empresas vigentes)</span>
                    </v-tooltip>
                  </template>
                  <v-list>
                    <v-list-item @click="downloadRelatorioPendencias(true)">
                      <v-list-item-title>Todas Pedencias</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="downloadRelatorioPendenciasStatus(1, true)">
                      <v-list-item-title>Aprovado</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="downloadRelatorioPendenciasStatus(0, true)">
                      <v-list-item-title>Reprovado</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="downloadRelatorioPendenciasStatus(2, true)">
                      <v-list-item-title>Aguardando Arquivos</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="downloadRelatorioPendenciasStatus(3, true)">
                      <v-list-item-title>Aguardando Aprovação</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>


                &nbsp;
                <v-btn v-if="verificarPermissao(2)" color="warning" fab x-small dark @click="editar()"
                  title="Editar Dados Departamento"><v-icon>mdi-pencil</v-icon></v-btn>&nbsp;
                <v-btn v-if="verificarPermissao(3)" color="error" fab x-small dark @click="inativar()"
                  title="Excluir Departamento"><v-icon>mdi-trash-can</v-icon></v-btn>
              </v-card-actions>
            </div>
            <div v-if="novo || departamento.id === 0">
              <v-form v-model="valid" ref="form">
                <v-divider></v-divider>
                <h3 class="headline mb-2" v-if="departamentoCadastro.id === 0 || departamento.id === 0">
                  Cadastro de Departamento
                </h3>
                <h3 class="headline mb-2" v-else>Edição</h3>
                <v-row>
                  <v-col cols="12">
                    <v-text-field v-model="departamentoCadastro.nome" label="Nome" clearable :rules="[rules.required]"
                      required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-checkbox v-model="departamentoCadastro.cadastroEntidades"
                      label="Permitir o cadastro de entidades?"></v-checkbox>
                  </v-col>
                </v-row>
                <v-card-actions class="justify-center">
                  <v-btn color="success" fab x-small dark @click="salvar()" title="Salvar" :disabled="saving"><i
                      class="fas fa-save fa-2x"></i></v-btn>&nbsp;
                </v-card-actions>
              </v-form>
            </div>
          </v-card>
        </v-scroll-y-transition>
      </v-col>
    </v-row>
    <TelaLoading :overlay="saving"></TelaLoading>
  </v-card>
</template>

<script>
import ApiService from "@/common/services/http/api.service";
import Swal from "sweetalert2";
import SweetAlert from "@/common/services/sweetalert.service";
import TelaLoading from "@/views/components/TelaLoading.vue";
import Permissoes from "@/common/services/permissoes/permissoes.js";
import Modulo from "@/common/services/permissoes/modulos.js";
import PermissoesService from "@/common/services/permissoes/permissoes.service.js";
import RelatorioService from "@/common/services/http/relatorio.service";
import { SET_LOADING } from "@/store/config.module";

export default {
  data: () => ({
    valid: false,
    saving: false,
    departamentos: [],
    cliente: {},
    departamento: null,
    permissoesPadrao: null,
    departamentoCadastro: {
      id: 0,
      departamentoSuperiorID: null,
      clienteID: 0,
      nome: "",
      cadastroEntidades: false,
    },
    open: ["public"],
    rules: {
      required: (v) => !!v || "Obrigatório",
    },
    configExportarPendencias: {
      pendenciasExportar: [],
      nomeArquivo: "",
    },
    novo: false,
  }),

  components: {
    TelaLoading,
  },

  methods: {
    novoRoot() {
      this.departamento = {
        id: 0,
        departamentoSuperiorID: null,
        clienteID: this.cliente.id,
        nome: "",
      };
    },
    carregarDados(item) {
      this.novo = false;
      this.buscarDepartamento(item.id);
    },

    async downloadRelatorioPendencias(listarApenasEmpresasVigentes = false) {
      this.$store.commit(SET_LOADING, true);
      let config = await RelatorioService.relatorioPendencias({
        departamentoID: this.departamento.id,
        listarApenasEmpresasVigentes
      });
      this.$store.commit(SET_LOADING, false);

      if (config) {
        this.configExportarPendencias = config;
        setTimeout(() => {
          this.$refs[
            "download-relatorio-pendencias-" + this.departamento.nome
          ].$el.click();
        }, 1000);
      }
    },
    async downloadRelatorioPendenciasStatus(statusPendencia, listarApenasEmpresasVigentes = false) {
      this.$store.commit(SET_LOADING, true);
      let config = await RelatorioService.relatorioPendenciasStatus({
        departamentoID: this.departamento.id,
        listarApenasEmpresasVigentes,
        status: statusPendencia,
      });
      this.$store.commit(SET_LOADING, false);

      if (config) {
        this.configExportarPendencias = config;
        setTimeout(() => {
          this.$refs[
            "download-relatorio-pendencias-" + this.departamento.nome
          ].$el.click();
        }, 1000);
      }
    },

    buscarDepartamento(id) {
      return new Promise((resolve) => {
        ApiService.get("departamento/" + id).then(({ data }) => {
          if (data.success) {
            resolve(data);
            this.departamento = data.data;
          } else SweetAlert.sweetAlertError(data.errors);
        });
      });
    },

    listaDepartamentos() {
      return new Promise((resolve) => {
        ApiService.get("departamento/gettreeviewbyclienteid", this.cliente.id, {
          filtrarUsuario: true,
        }).then(({ data }) => {
          if (data.success) {
            resolve(data);
            this.departamentos = data.data;
          } else SweetAlert.sweetAlertError(data.errors);

          this.$store.commit(SET_LOADING, false);
        });
      });
    },

    novoCadastro() {
      this.novo = true;
      this.limparCadastro();
    },

    limparCadastro() {
      this.departamentoCadastro.id = 0;
      this.departamentoCadastro.departamentoSuperiorID = null;
      this.departamentoCadastro.clienteID = 0;
      this.departamentoCadastro.nome = "";
      this.departamentoCadastro.cadastroEntidades = false;
    },

    editar() {
      this.novo = true;
      this.departamentoCadastro = this.departamento;
    },

    salvar() {
      let self = this;

      if (this.$refs.form.validate()) {
        this.saving = true;

        if (this.departamentoCadastro.id === 0) {
          this.departamentoCadastro.departamentoSuperiorID =
            this.departamento.id === 0 ? null : this.departamento.id;
          this.departamentoCadastro.clienteID = this.cliente.id;

          return new Promise((resolve) => {
            ApiService.post("departamento", this.departamentoCadastro).then(
              ({ data }) => {
                if (data.success) {
                  resolve(data);
                  Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Departamento Cadastrado com Sucesso!",
                    showConfirmButton: false,
                    timer: 1500,
                  }).then(function () {
                    self.departamento = null;
                    self.novo = false;
                    self.limparCadastro();
                    self.listaDepartamentos();
                  });
                } else SweetAlert.sweetAlertError(data.errors);
              }
            );
          }).finally(() => (this.saving = false));
        } else {
          this.departamentoCadastro.cliente = null;
          this.departamentoCadastro.departamentoSuperior = null;

          return new Promise((resolve) => {
            ApiService.put(
              "departamento/" + this.departamentoCadastro.id,
              this.departamentoCadastro
            ).then(({ data }) => {
              if (data.success) {
                resolve(data);
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Departamento Alterado com Sucesso!",
                  showConfirmButton: false,
                  timer: 1500,
                }).then(function () {
                  self.departamento = null;
                  self.novo = false;
                  self.limparCadastro();
                  self.listaDepartamentos();
                });
              } else SweetAlert.sweetAlertError(data.errors);
            });
          }).finally(() => (this.saving = false));
        }
      }
    },

    verificarPermissao(permissao) {
      return PermissoesService.verificarAcesso(Modulo.Departamento, permissao);
    },

    inativar() {
      let self = this;

      const dep = this.departamentos.find((d) => d.id == this.departamento.id);

      if (dep != null && dep.children.length) {
        Swal.fire({
          title: "Possuem deparamentos filhos ativos",
          text: "Essa operação não poderá ser realizada!",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "Ok",
        });

        return;
      }
      Swal.fire({
        title: "Tem certeza que deseja excluir esse registro?",
        text: "Essa operação não poderá ser desfeita!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, pode excluir!",
      }).then(function (result) {
        if (result.value) {
          return new Promise((resolve) => {
            ApiService.put(
              "departamento/" + self.departamento.id + "/inativar"
            ).then(({ data }) => {
              resolve(data);

              if (data.success === true) {
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Departamento Inativado com Sucesso!",
                  showConfirmButton: false,
                  timer: 1500,
                }).then(function () {
                  self.departamento = null;
                  self.listaDepartamentos();
                });
              } else SweetAlert.sweetAlertError(data.errors);
            });
          });
        }
      });
    },
  },
  mounted() {
    this.$store.dispatch(SET_LOADING, true);
    this.cliente = JSON.parse(window.localStorage.getItem("cliente"));
    this.permissoesPadrao = Permissoes;
    this.listaDepartamentos();
  },
  created() {
    if (
      !PermissoesService.verificarAcesso(
        Modulo.Departamento,
        Permissoes.Visualizar
      )
    ) {
      SweetAlert.sweetAlertError([
        "Você não tem permissão para acessar essa parte do sistema",
      ]);
      this.$router.push({ name: "index" });
    }
  },
};
</script>
